import { _ } from "libs";
import React from "react";
import PostHeader from "../items/post/header";
import moment from "moment";
import { Link } from "react-router-dom";
import { ClubPost, ClubPostActivity } from "../../types";
import { prettyDate } from "../../actions/prettyDate";

const ClubPostItem = ({ post, activity }: { post: ClubPost; activity?: ClubPostActivity }) => {
	if (!activity.actor || !activity.actor.data) {
		return null;
	}
	let timestamp = String(moment(activity.time).unix());
	let date = prettyDate(timestamp, false);
	let imageRelativeHeight = post.photoDimensions
		? (post.photoDimensions.height / post.photoDimensions.width) * 100 + "%"
		: null;
	return (
		<div className="nBlock newsFeedPost">
			<Link to={`/club/${activity.actor.data.clubId}`}>
				<PostHeader
					avatarPhotoUrl={activity.actor.data.photoUrl ? activity.actor.data.photoUrl.replace("stage-", "") : null}
					title={activity.actor.data.name}
					meta={date}
				/>
			</Link>
			{post.photoUrl ? (
				<div className="postImage" style={{ backgroundImage: "url('" + post.photoUrl + "')" }}>
					<div className="aspectRatioFill" style={{ paddingTop: imageRelativeHeight }} />
				</div>
			) : null}
			{post.title ? <div className="postTitle">{post.title}</div> : null}
			{post.text ? <div className="postText">{post.text}</div> : null}
			{post.link && post.linkName ? (
				<div className="postAction">
					<a className="button small" href={post.link} target="_blank" rel="noopener noreferrer">
						{post.linkName}
					</a>
				</div>
			) : null}
			{post.link && !post.linkName ? (
				<div className="postAction">
					<a className="button small" href={post.link} target="_blank" rel="noopener noreferrer">
						{_("readmore")}
					</a>
				</div>
			) : null}
		</div>
	);
};

export default ClubPostItem;
